module.exports = __webpack_public_path__ + "static/media/press_content_07.1b30b00c.png";